// works with  1 area in the center - review below 
export function detectPosition(detectPositionTarget, detectPositionBg) {


  // Review the time + order in which this starts
  // We don't really want it to start untill after the loading sequnces is finished - once the text actually appaers

  // change the colour of the text, links and iconograpy: detectPositionTarget

  // set var for change colour
  let changeTargetColor = false;
  const bgViewer = document.querySelector("#bg-viewer"); // review declaring this in here...
  // I need to change the opacity on the inner container of the vg view - and have the icon to hint 0 change in the opacity oppposity direction

  // Set initial value
  let value = 0.01;

  // Function to handle adjustments based on distance
  function handleAdjustment(event) {


    if (!changeTargetColor) { 
      // review this if both functionsa are running at the same time - i.e 2 event listener and this function
      // this shouldn't happend anywy - will be resovled when I tie in the touch detecting function and then rune only 1 event listener accordingly
      // console.log('detectPositionTarget', detectPositionTarget, "change colour here");
      detectPositionTarget.style.setProperty('--active-color', '#000'); // review target and the need to use gsap to change the colour

      // / ensure opacity is set back to 1 after "intro dimming"
      bgViewer.style.opacity = 1; 
      // Update the flag to indicate that the colour change has occurred
      changeTargetColor = true;
    }

    const touch = (event.type === 'touchmove') ? event.touches[0] : null;
    const clientX = touch ? touch.clientX : event.clientX;
    const clientY = touch ? touch.clientY : event.clientY;
    // const targetRect = detectPositionTarget.getBoundingClientRect();
    const targetRect = bgViewer.getBoundingClientRect();
    // Calculate the distance from the center of the target object
    const centerX = targetRect.left + targetRect.width / 2;
    const centerY = targetRect.top + targetRect.height / 2;
    const Xright = targetRect.width;
    const Ybottom = targetRect.height;

    // console.log("Xright", Xright, "Ybottom", Ybottom, "centerX", centerX, "centerY", centerY, "clientX", clientX, "clientY", clientY)
   
    
    const distance = calculateDistance({
      x: clientX,
      y: clientY
    }, {
      // x: centerX,
      // y: centerY
      x: Xright,
      y: Ybottom
    });

    // Adjust the value based on the distance with power function
    value = powerAdjustment(distance, Math.min(window.innerWidth, window.innerHeight) / 2);


    // console.log("bgOpacity", value, "bgOpacity", 1 - value)


    // Reverse the value for the background
    let bgOpacity = 1 - value;

    // Clamp the values between 0.01 and 1
    value = Math.max(0.01, Math.min(1, value));
    bgOpacity = Math.max(0.01, Math.min(1, bgOpacity));

    // Do something with the adjusted values
    // console.log('Adjusted value (targetObject):', value);
    // console.log('Adjusted value (bg):', bgOpacity);
    // detectPositionTarget.style.opacity = value;
    // detectPositionBg.style.opacity = bgOpacity;
//reversing the assigned values
    detectPositionTarget.style.opacity = bgOpacity;
    detectPositionBg.style.opacity = value;
  }

  // Add touchmove event listener to the whole document
  document.addEventListener('touchmove', handleAdjustment);

  // Add mousemove event listener to the whole document
  document.addEventListener('mousemove', handleAdjustment);

  //change colour here:


  // Add resize event listener to adjust for changes in screen size
  window.addEventListener('resize', function () {
    // Re-adjust when the screen size changes
    handleAdjustment({
      type: 'resize'
    });
  });
}


export function calculateDistance(point1, point2) {
  const dx = point1.x - point2.x;
  const dy = point1.y - point2.y;
  return Math.sqrt(dx * dx + dy * dy);
}

export function powerAdjustment(distance, maxDistance) {
  // Power adjustment function
  // You may need to adjust the constants to achieve the desired effect
  const a = 0.01; // Minimum value (when distance is 0)
  const b = 1; // Adjustment strength
  const c = 2; // Power factor

  return a + (1 - a) * Math.pow(1 - distance / (c * maxDistance), b);
}



// with "2 areas" - continue chat with open ai to fine tunes

// export function detectPosition(detectPositionTarget, detectPositionBg) {
//   // Set initial value
//   let value = 0.01;

//   // Function to handle adjustments based on distance
//   function handleAdjustment(event) {
//     const touch = (event.type === 'touchmove') ? event.touches[0] : null;
//     const clientX = touch ? touch.clientX : event.clientX;
//     const clientY = touch ? touch.clientY : event.clientY;

//     const targetRect = detectPositionTarget.getBoundingClientRect();

//     // Calculate the distance from the top left of the target object
//     const distanceFromTopLeft = calculateDistance(
//       { x: clientX, y: clientY },
//       { x: targetRect.left, y: targetRect.top }
//     );

//     // Calculate the distance from the center of the target object
//     const centerX = targetRect.left + targetRect.width / 2;
//     const centerY = targetRect.top + targetRect.height / 2;
//     const distanceFromCenter = calculateDistance(
//       { x: clientX, y: clientY },
//       { x: centerX, y: centerY }
//     );

//     // Use a mathematical function to control the opacity
//     value = smoothOpacityTransition(distanceFromTopLeft, distanceFromCenter);

//     // Reverse the value for the background
//     let bgOpacity = 1 - value;

//     // Clamp the values between 0.01 and 1
//     value = Math.max(0.01, Math.min(1, value));
//     bgOpacity = Math.max(0.01, Math.min(1, bgOpacity));

//     // Do something with the adjusted values
//     console.log('Adjusted value (targetObject):', value);
//     console.log('Adjusted value (bg):', bgOpacity);
//     detectPositionTarget.style.opacity = value;
//     detectPositionBg.style.opacity = bgOpacity;
//   }

//   // Add touchmove event listener to the whole document
//   document.addEventListener('touchmove', handleAdjustment);

//   // Add mousemove event listener to the whole document
//   document.addEventListener('mousemove', handleAdjustment);

//   // Add resize event listener to adjust for changes in screen size
//   window.addEventListener('resize', function () {
//     // Re-adjust when the screen size changes
//     handleAdjustment({ type: 'resize' });
//   });
// }

// export function calculateDistance(point1, point2) {
//   const dx = point1.x - point2.x;
//   const dy = point1.y - point2.y;
//   return Math.sqrt(dx * dx + dy * dy);
// }

// export function smoothOpacityTransition(distanceFromTopLeft, distanceFromCenter) {
//   // Use a mathematical function to control the opacity transition
//   // You may need to adjust the constants to achieve the desired effect
//   const a = 0.01;   // Minimum value (when distance is 0)
//   const b = 1;      // Adjustment strength
//   const c = 2;      // Power factor

//   // Adjust this formula based on how you want the opacity to transition
//   return a + (1 - a) * Math.pow(1 - (distanceFromTopLeft + distanceFromCenter) / (c * Math.min(window.innerWidth, window.innerHeight)), b);
// }